import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';

const Popover = (props) => {
  const { content, wrapperStyle, popoverStyle, } = props;
  const styles = useStyles({ wrapperStyle, popoverStyle, });
  // eslint-disable-next-line react/prop-types
  const { handler = <i className={`material-icons ${styles.handlerIcon}`}>help_outline</i>, } = props;
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef();
  const handlerRef = useRef();

  const handleClick = () => setIsOpen(!isOpen);

  const handleClickOutside = (event) => {
    if (!isOpen) {
      return;
    }

    const isClickedInside = popoverRef.current.contains(event.target);
    const isClickedOnHandler = handlerRef.current.contains(event.target);

    if (!isClickedInside && !isClickedOnHandler) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleClickOutside, true);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [isOpen]);

  return (
    <span className={styles.wrapper}>
      <span className={styles.handler} ref={handlerRef} onClick={() => handleClick()}>{handler}</span>
      { isOpen &&
        <div className={styles.popover} ref={popoverRef}>
          {content}
        </div>
      }
    </span>
  );
};

const useStyles = createUseStyles({
  wrapper: (props) => ({
    ...props.wrapperStyle,
  }),
  handler: {
    cursor: 'pointer',
  },
  handlerIcon: {
    fontSize: 18,
    color: '#c7c7c7',
    transition: 'all 0.2s',
    position: 'absolute',
    '&:hover': {
      color: '#57c2ef',
    },
  },
  popover: (props) => ({
    top: '26%',
    left: '50%',
    minWidth: '250px',
    maxWidth: '500px',
    padding: 24,
    position: 'absolute',
    transform: 'translateX(-50%)',
    zIndex: 101,
    backgroundColor: '#ffffff',
    borderRadius: 4,
    boxShadow: '1px 2px 8px 0px rgba(0, 0, 0, 0.25)',
    ...props.popoverStyle,
  }),
  '@media (max-width: 652px)': {
    popover: {
      minWidth: '300px !important',
      maxWidth: '300px !important',
    },
  },
});

Popover.propTypes = {
  content: PropTypes.string.isRequired,
  wrapperStyle: PropTypes.object,
  popoverStyle: PropTypes.object,
};

Popover.defaultProps = {
  wrapperStyle: {},
  popoverStyle: {},
}

export default Popover;
